import { Link } from "react-router-dom";
import { RouteEnum } from "../../enums/RouteEnum";
import { useAppDispatch, useAppLocation } from "../../../app/hooks";
import { JSX } from "react";
import { menuToggle } from "../../../app/rootReducer";

export const Navigation = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const location = useAppLocation();

    const menuItems = [
        {
            logo: "/images/icons/coffee.svg",
            route: RouteEnum.PRODUCT_RANGE,
        },
        {
            logo: "/images/icons/favourites-white.svg",
            route: RouteEnum.BRANDING,
        },
    ];

    return (
        <nav className="l-app__menu__nav">
            <ul className="u-reset-ul">
                {menuItems.map((menuItem) => {
                    let className = "";

                    if (location.pathname.includes(menuItem.route)) {
                        className += "isActive";
                    }

                    return (
                        <li
                            className={className}
                            key={"dashboard-navigation: " + menuItem.route}
                        >
                            <Link
                                to={menuItem.route}
                                onClick={() => dispatch(menuToggle())}
                            >
                                <div className="icon">
                                    <img src={menuItem.logo} alt="logo" />
                                </div>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
